
import { Link } from "react-router-dom"

const NotFoundPage = () => {
    return (
        <div className="bg-[white] dark:bg-dark-content-bg dark:text-white lg:ml-[250px] transition-colors duration-300 ease-in-out">
            <div className="flex flex-col items-center justify-center w-full h-[80vh]">
                <h1 className="font-bold text-base lg:text-lg 2xl:text-xl">404 Page Not Found</h1>
                <div className="flex items-center text-base lg:text-lg 2xl:text-xl">
                    <Link to = '/' className="text-center font-bold mr-2">Click </Link>
                    <p>to go back to home</p> 
                </div>
            </div>
        </div>
    )
}

export default NotFoundPage;